import { render, staticRenderFns } from "./console.vue?vue&type=template&id=84b4c25e&scoped=true&"
import script from "./console.vue?vue&type=script&lang=js&"
export * from "./console.vue?vue&type=script&lang=js&"
import style0 from "./console.vue?vue&type=style&index=0&id=84b4c25e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b4c25e",
  null
  
)

export default component.exports